import { User, UserProfileProperties } from '../types/common/user';

/**
 * Name to show for a user: their SharePoint PreferredDisplayName when they have
 * one, otherwise their FullName. Profile properties load separately from the
 * user, so either side may be missing.
 */
export function getDisplayName(
    user: User | null | undefined,
    profileProperties: UserProfileProperties | null | undefined
): string {
    const preferred = profileProperties?.PreferredDisplayName?.trim();
    return preferred ? preferred : user?.FullName ?? '';
}

/**
 * First name out of getDisplayName — for greetings. FullName comes across as
 * "First Last", PreferredDisplayName is usually already just the first name.
 */
export function getDisplayFirstName(
    user: User | null | undefined,
    profileProperties: UserProfileProperties | null | undefined
): string {
    return getDisplayName(user, profileProperties).split(' ')[0] ?? '';
}
